import styled from 'styled-components';

import { tokens } from '../theme/tokens';

export const KeyBinding = styled.div`
	padding: 2px;
	font-size: 14px;
	border: 1px solid ${tokens.border.subtle};
	border-bottom: 2px solid ${tokens.border.subtle};
	border-radius: 4px;
	background: white;
	font-size: 10px;
	color: ${tokens.text.secondary};
`;
